__turbopack_context__.v({
  "page": "index-module__gn4PgW__page",
});
